import requestAResponseFromWork from "./requestAResponseFromWork";
import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/staffer",
  },
  modules: {
    "request-a-response-from-work": requestAResponseFromWork,
  },
  actions: {
    "check-is-teacher"({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/check-is-teacher?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "get-teachers"({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/teachers?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
  },
};
